<template>
  <page-loader>
    <v-container>
      <v-row>
        <v-col>
          <filter-accordion
            :loading="isLoading"
            :query-changed="$_queryHandler_hasQueryChanged"
            :query-count="$_queryHandler_numberOfQueries"
            @clear-filters="$_queryHandler_resetFilters"
          >
            <template #search>
              <search-input v-model="query.searchTerm" clearable hide-details outlined />
            </template>

            <template #content>
              <v-data-table
                :headers="tableHeaders"
                :items="filteredSiteGroups"
                :footer-props="tableFooterProps"
                :loading="isLoading"
                :server-items-length="pagination.total"
                fixed-width
                disable-sort
                @pagination="handleQueryUpdate"
              >
                <template #item="{ item }">
                  <v-hover #default="{ hover }">
                    <tr>
                      <td>{{ item.name }}</td>
                      <td>{{ item.notification_channel }}</td>
                      <td align="right">
                        <div v-show="hover">
                          <more-menu>
                            <v-list-item
                              :disabled="!isPermittedTo('update')"
                              :inactive="!isPermittedTo('update')"
                              @click="toggleEditModal(item)"
                            >
                              <v-list-item-title>Edit</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              :disabled="!isPermittedTo('delete')"
                              :inactive="!isPermittedTo('delete')"
                              @click="handleDelete(item)"
                            >
                              <v-list-item-title>Delete</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              :disabled="!isPermittedTo('update')"
                              :inactive="!isPermittedTo('update')"
                              @click="handleViewSites(item)"
                            >
                              <v-list-item-title>View Sites</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              :disabled="!isPermittedTo('update')"
                              :inactive="!isPermittedTo('update')"
                              @click="togglePageTypeModal(item)"
                            >
                              <v-list-item-title>View Page Types</v-list-item-title>
                            </v-list-item>
                          </more-menu>
                        </div>
                      </td>
                    </tr>
                  </v-hover>
                </template>
              </v-data-table>
            </template>
          </filter-accordion>
        </v-col>
      </v-row>
    </v-container>
    <fab-create v-if="isPermittedTo('create')" type="Page" @click="toggleCreateModal" />
    <create-modal v-model="showCreateModal" @cancel="toggleCreateModal" />
    <edit-modal v-model="showEditModal" :item="selectedItem" @cancel="toggleEditModal" />
    <page-type-modal v-model="showPageTypeModal" :item="selectedItem" @cancel="togglePageTypeModal" />
  </page-loader>
</template>

<script>
import { mapMutations } from 'vuex'

import { siteGroups } from '@/services/offers'

import FilterAccordion from '@/components/filter-accordion'
import FabCreate from '@/components/fab-create'
import PageLoader from '@/components/page-loader'
import SearchInput from '@/components/forms/search-input'
import MoreMenu from '@/components/more-menu'
import CreateModal from './components/create-modal'
import EditModal from './components/edit-modal'
import PageTypeModal from './components/page-type-modal'

import PermissionsHandler from '@/mixins/permissions-handler'
import QueryParamsHandler from '@/mixins/query-params-handler'

export default {
  name: 'SiteGroupsIndex',
  components: {
    PageLoader,
    FabCreate,
    SearchInput,
    FilterAccordion,
    MoreMenu,
    CreateModal,
    EditModal,
    PageTypeModal,
  },
  mixins: [PermissionsHandler, QueryParamsHandler],
  data: () => ({
    isLoading: false,
    showCreateModal: false,
    showEditModal: false,
    showPageTypeModal: false,
    selectedItem: null,
    siteGroups: [],
    tableHeaders: [
      { text: 'Name', value: 'name' },
      { text: 'Notification Channel', value: 'notification_channel' },
      { text: '', align: 'end', width: 77 },
    ],
    pagination: { total: 0 },
    tableFooterProps: {
      itemsPerPageOptions: [20, 50, 100],
    },
  }),
  computed: {
    filteredSiteGroups() {
      return this.siteGroups
    },
  },
  async created() {
    await this.handleQueryUpdate()
    this.setPageLoading(false)
  },
  methods: {
    ...mapMutations({
      setPageLoading: 'general/setPageLoading',
    }),
    async handleQueryUpdate({ page = 1, itemsPerPage = 20 } = {}) {
      const search = this.query.searchTerm
      const paginate = { perPage: itemsPerPage, page }
      const { data, pagination } = await siteGroups.getAll({ search, paginate })
      this.pagination = pagination
      this.siteGroups = data
    },
    toggleCreateModal() {
      this.showCreateModal = !this.showCreateModal
      this.handleQueryUpdate({})
    },
    toggleEditModal(item) {
      this.showEditModal = !this.showEditModal
      this.selectedItem = this.showEditModal ? item : null
      this.handleQueryUpdate({})
    },
    togglePageTypeModal(item) {
      this.showPageTypeModal = !this.showPageTypeModal
      this.selectedItem = this.showPageTypeModal ? item : null
      this.handleQueryUpdate({})
    },
    handleViewSites({ id }) {
      this.$router.push({ name: 'sites.management', query: { site_group_id: id } })
    },
    handleDelete() {
      //
    },
  },
}
</script>
